<template>
  <div :style="{color:color,background:bgColor}" class="week-box">
    {{week}}
  </div>
</template>

<script>
export default {
  props:{
    week:{
      type:String,
      default:null
    },
    color:{
      type:String,
      default:'#fff'
    },
    bgColor:{
      type:String,
      default:'#ff5c5d'
    }
  }
}
</script>

<style lang="scss" scoped>
  .week-box{
    font-size: 16px;
    line-height: 30px;
    height:30px;
  }
</style>
